import React from 'react';

import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogFooter,
	DialogClose,
} from '@/components/ui/dialog';
import { CustomButton } from '@/components/ui/custom/CustomButton';

const DeleteMessageDialog = ({ open, handleDeleteMessage, onClose }) => {
	return (
		<Dialog open={open} onOpenChange={onClose}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Delete message?</DialogTitle>
				</DialogHeader>
				<div>Are you sure you want to delete this message?</div>
				<DialogFooter>
					<DialogClose asChild>
						<CustomButton variant="outline">Close</CustomButton>
					</DialogClose>

					<CustomButton
						variant="default"
						onClick={() => {
							handleDeleteMessage();
							onClose(); // Manually close the dialog
						}}
					>
						Yes
					</CustomButton>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default DeleteMessageDialog;
